import React from 'react';
import classnames from 'classnames';
import FormControl from '@material-ui/core/FormControl';

import InputField from 'components/common/Study/InputField';
import styles from './AddEmailLayout.scss';

const VerifyEmail = ({ email, onEmailChange, emailErrorMsg }) => {
    return (
        <FormControl className={styles.drawerContainer__body__emailInputWrapper} variant="outlined">
            <InputField required={true} label="Enter Email Address" htmlFor="emailInput">
                <div data-cy="VerifyEmail">
                    <input
                        className={classnames(styles.drawerContainer__body__emailInput, {
                            [styles.colorError]: emailErrorMsg,
                            [styles.borderError]: emailErrorMsg,
                        })}
                        placeholder="email@example.com"
                        name="emailInput"
                        value={email}
                        onChange={onEmailChange}
                        data-id="verify-email-input"
                        data-cy="VerifyEmail-onEmailChange"
                    />
                    {emailErrorMsg && (
                        <div
                            className={classnames(styles.feedbackMsg, { [styles.colorError]: !!emailErrorMsg })}
                            data-id="verify-email-error-msg"
                            data-cy="VerifyEmail-emailErrorMsg"
                        >
                            {emailErrorMsg}
                        </div>
                    )}
                </div>
            </InputField>
        </FormControl>
    );
};

export default VerifyEmail;
